import Header from './components/Header';
import Hero from './components/Hero';
import Updates from './components/Updates';
import Comments from './components/Comments';
import IndexSection from './components/IndexSection';
import FAQ from './components/FAQ';
import Features from './components/Features';
import AppEntry from './components/AppEntry';
import Cards from './components/Cards';
import Ranking from './components/Ranking';
import MediaSection from './components/MediaSection';
import Carousel from './components/Carousel';
import Topics from './components/Topics';
import Contact from './components/Contact';
import About from './components/About';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="relative min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <Updates />
        <Comments />
        <IndexSection />
        <FAQ />
        <Features />
        <AppEntry />
        <Cards />
        <Ranking />
        <MediaSection />
        <Carousel />
        <Topics />
        <Contact />
        <About />
      </main>
      <Footer />
    </div>
  );
}